import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query CurrentTradeMetaPixel {\n    me {\n      id\n      currentTrade {\n        id\n        marketingPixels\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
import React from "react";
import { Query } from "react-apollo";
import { useLocation } from "react-router-dom";
import { useAuth } from "@saleor/sdk";
var META_PIXEL_SCRIPT_ID = "meta-pixel-script";
var currentTradeMetaPixelQuery = gql(_templateObject());
var initializedPixelIds = new Set();

var injectMetaPixelScript = function injectMetaPixelScript() {
  if (document.getElementById(META_PIXEL_SCRIPT_ID)) {
    return;
  }

  var script = document.createElement("script");
  var firstScript = document.getElementsByTagName("script")[0];
  script.id = META_PIXEL_SCRIPT_ID;
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";

  if (firstScript === null || firstScript === void 0 ? void 0 : firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
};

var configureMetaPixelQueue = function configureMetaPixelQueue() {
  if (window.fbq) {
    return;
  }

  var queue = [];

  var fbq = function fbq() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args);
    } else {
      queue.push(args);
    }
  };

  fbq.queue = queue;
  fbq.loaded = true;
  fbq.version = "2.0";
  window.fbq = fbq;
  window._fbq = fbq;
};

var initializeMetaPixel = function initializeMetaPixel(pixelId) {
  configureMetaPixelQueue();
  injectMetaPixelScript();

  if (!initializedPixelIds.has(pixelId)) {
    var fbq = window.fbq;

    if (!fbq) {
      return;
    }

    fbq("init", pixelId);
    initializedPixelIds.add(pixelId);
  }
};

var MetaPixelTracker = function MetaPixelTracker(_ref) {
  var _currentTrade$marketi;

  var currentTrade = _ref.currentTrade;
  var location = useLocation();
  var metaPixel = currentTrade === null || currentTrade === void 0 ? void 0 : (_currentTrade$marketi = currentTrade.marketingPixels) === null || _currentTrade$marketi === void 0 ? void 0 : _currentTrade$marketi.meta;
  var metaPixelId = metaPixel === null || metaPixel === void 0 ? void 0 : metaPixel.pixelId;
  var isMetaPixelEnabled = metaPixel === null || metaPixel === void 0 ? void 0 : metaPixel.enabled;
  React.useEffect(function () {
    if (isMetaPixelEnabled && metaPixelId) {
      initializeMetaPixel(metaPixelId);
    }
  }, [isMetaPixelEnabled, metaPixelId]);
  React.useEffect(function () {
    var fbq = window.fbq;

    if (isMetaPixelEnabled && metaPixelId && fbq) {
      fbq("trackSingle", metaPixelId, "PageView");
    }
  }, [isMetaPixelEnabled, metaPixelId, location.pathname, location.search]);
  return null;
};

export var MetaPixelLoader = function MetaPixelLoader() {
  var _useAuth = useAuth(),
      user = _useAuth.user;

  if (!(user === null || user === void 0 ? void 0 : user.id)) {
    return null;
  }

  return React.createElement(Query, {
    fetchPolicy: "cache-and-network",
    query: currentTradeMetaPixelQuery
  }, function (queryResult) {
    var _queryResult$data, _queryResult$data$me;

    return React.createElement(MetaPixelTracker, {
      currentTrade: ((_queryResult$data = queryResult.data) === null || _queryResult$data === void 0 ? void 0 : (_queryResult$data$me = _queryResult$data.me) === null || _queryResult$data$me === void 0 ? void 0 : _queryResult$data$me.currentTrade) || null
    });
  });
};